module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (100).b47e0e1b.jpg";